import script from "./RequestFundsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestFundsModal.vue?vue&type=script&setup=true&lang=js"

import "./RequestFundsModal.vue?vue&type=style&index=0&id=6b4735ef&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4735ef"]])

export default __exports__